export default __webpack_public_path__ + "static/media/thumbnail.7e2ed15b.webp";